import axios, { Axios } from 'axios';
import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Paper, Stack, Pagination, TextField } from "@mui/material";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const Partnerships = (props) =>{
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [editPartnershipObj, setEditPartnershipObj] = useState({});
    const [partnershipsItems, setPartnershipsList] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });
    const [sortModel, setSortModel] = useState([]);
    useEffect(()=>{
        //fetch partnerships
        axios.get('/api/basic/BP_Partnership', { headers:{
            'content-type': 'application/json'
        }

        }).then((response) => {
            //console.log('Partnerships Returned: ',response.data);
            setPartnershipsList(response.data);
        }).catch((err) => {
            //alert error
            enqueueSnackbar(err);
        })

    },[]);

    

   const [open, setOpen] = useState(false);
   const handleClose = () => setOpen(false);
   const [editMode, setEditMode] = useState(false);
 
   //adding Partnership
   const handleAddPartnership = () => {
     setEditMode(false);
     //Add IsPartnership, ProjectCode, ReceiptNumber, IsEventCode, IsProjectCode, IsDeleted
     setEditPartnershipObj({ItemID:0, Name: '', IsPartnership:true});
     setOpen(true);
   }

   const handleEdit = (obj,params) =>{
    setEditPartnershipObj(params.row);
    setEditMode(true);
    setOpen(true);
    enqueueSnackbar("We are editing a row with these values: " + JSON.stringify(params.row));
   }

    const handleDelete = (obj,params) =>{
        axios.post('/api/basic/BP_Parntnership', {data: {"ItemID": params.row["ItemID"]}}).then((response)=> {
            if(response.status==200){
                enqueueSnackbar('Partnership Successfully Deleted!'); 
            }else{
                enqueueSnackbar("Something went wrong");
            }
        
        }).catch((exception)=> {
            enqueueSnackbar('Whoops, error occurred: ' + exception);
        })
    }

    //handlefieldchange
  function handleFieldChange(input){
    const target = input.target;
    const value = target.value;
    const name = target.id;
    //console.log(name,value);
    setEditPartnershipObj({...editPartnershipObj,
      [name]: value
    });
}

    const columns = [
        {
          field: "Edit", width:150,
          renderCell: (cellValues) => {
            return (
              <div>
              <Button
                variant="contained"
                color="error"
                onClick={(event) => {
                  event.ignore = true;
                  handleEdit(event, cellValues);
                }}
              >
                Edit
              </Button> 
              </div>
            );
          }
        },
        { field: 'ItemID', headerName: 'ID', width:100 },
        { field: 'Name', headerName: 'Partnership', width:300 },
        { field: 'Delete', width:150, renderCell: (cellValues) => {
            return (
                <div>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={(event) => {
                        event.ignore = true;
                        handleDelete(event, cellValues);
                        }}
                        >
                        Delete
                    </Button> 
                </div>
            )
        }}
      ];

      const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 700,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };

      const handleSubmit = async e => {
        e.preventDefault();
        //console.log(editPartnershipObj);
        let response = await axios.post('/api/basic/BP_Partnership', editPartnershipObj)
          
        if (response) {
          //get new token stuff
          if(response.data.includes('Validation failed'))
          {
            //console.log(response.data);
            enqueueSnackbar(response.data);
          }
          else{
            //console.log(response);
            enqueueSnackbar("Partnership Saved");
            //getData();
            handleClose();
          }
          
        } else {
          //enqueueSnackbar(error.message);
        }
      }

    // Sort the ENTIRE list (not just the current page) before paginating.
    const sortedPartnershipsItems = (() => {
      if (!sortModel.length) return partnershipsItems;
      const { field, sort } = sortModel[0];
      if (!field || !sort) return partnershipsItems;
      const dir = sort === 'desc' ? -1 : 1;
      return [...partnershipsItems].sort((a, b) => {
        const av = String(a?.[field] ?? '').toLowerCase();
        const bv = String(b?.[field] ?? '').toLowerCase();
        if (av < bv) return -1 * dir;
        if (av > bv) return 1 * dir;
        return 0;
      });
    })();

    return (
        <div>
            <Box sx={{ backgroundColor: '#f8f9fa', padding: '16px', borderRadius: '8px', marginBottom: '16px' }}>
              <Button onClick={handleAddPartnership} color='primary'>Add Partnership</Button>
            </Box>
            <DataGrid
              autoHeight
              hideFooterPagination
              columns={columns}
              rows={sortedPartnershipsItems.slice(
                paginationModel.page * paginationModel.pageSize,
                (paginationModel.page + 1) * paginationModel.pageSize
              )}
              getRowId={(row) => row.ItemID}
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={(m) => {
                setSortModel(m);
                setPaginationModel((prev) => ({ ...prev, page: 0 }));
              }}
            />

            <Paper sx={{ padding: '16px', marginTop: '16px', boxShadow: 'none' }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%', gap: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  Showing {partnershipsItems.length > 0 ? (paginationModel.page * paginationModel.pageSize) + 1 : 0} to{' '}
                  {Math.min((paginationModel.page + 1) * paginationModel.pageSize, partnershipsItems.length)} of {partnershipsItems.length} partnerships
                </Typography>

                <Stack direction="row" alignItems="center" sx={{ gap: 2 }}>
                  <Pagination
                    count={Math.ceil(partnershipsItems.length / paginationModel.pageSize) || 1}
                    page={paginationModel.page + 1}
                    onChange={(_, page) => setPaginationModel((prev) => ({ ...prev, page: page - 1 }))}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    className="rolesPagination"
                  />
                </Stack>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, whiteSpace: 'nowrap' }}>
                  <Typography variant="body2" color="text.secondary">Show:</Typography>
                  <TextField
                    select
                    size="small"
                    value={paginationModel.pageSize}
                    onChange={(e) => {
                      const newLimit = parseInt(e.target.value);
                      setPaginationModel((prev) => ({ ...prev, pageSize: newLimit, page: 0 }));
                    }}
                    SelectProps={{ native: true }}
                    sx={{ minWidth: 80 }}
                    className="pageSizeField"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </TextField>
                  <Typography variant="body2" color="text.secondary">per page</Typography>
                </Box>
              </Stack>
            </Paper>
            <div className="collapse" id="add-partnership">
            <Modal open={open} onClose={handleClose} aria-labelledby='title' aria-describedby=''>
                <Box sx={modalStyle}>
                    <Typography id="title" variant='h5'>Add Partnership</Typography>
            <form onSubmit={handleSubmit}>
              <div className="row pt-5">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="required-caption"><span className="required-field">*</span>Partnership Name</label>
                    <input id="Name" type="text" maxLength="200" className="form-control" value={editPartnershipObj.Name} placeholder="Partnership Name" onChange={handleFieldChange}/>
                  </div>
                </div>
                <div className="col-md-6 text-white py-1 d-flex gap-2"> 
                <a data-toggle="collapse" role="button" aria-expanded="false" aria-controls="save-skills" onClick={handleSubmit} className="button-default button-green collapsed">Save</a>
                <a data-toggle="collapse" onClick={handleClose} role="button" aria-expanded="false" aria-controls="cancel-skills" className="button-default button-gray collapsed">Cancel</a>
                </div>
                <div className="col-md-6 text-white py-1 text-right px-0"> 
                { editMode && <a data-toggle="collapse" role="button" aria-expanded="false" aria-controls="delete-skills" className="button-default button-red collapsed">Delete</a>  }
                </div>
              </div>
           </form> 
           </Box>
          </Modal>
           </div>
        </div>
    )
}

export default Partnerships;